import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useGet } from '../../hooks/process-data'
import { useHistory, useParams } from 'react-router-dom'
import ZoneGeneralForm from './zone-form/ZoneGeneralForm'
import ZoneBoxForm from './zone-form/ZoneBoxForm'
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch'
import Layout from '../home/theme/Layout'
import { EventPage } from '../../layout/event/event-page'
import LoadingIcon from '../../components/loading/LoadingIcon'
import { appUrl } from '../../utils'
import { apiResource } from '../../utils'

export default function EventDetail() {
  const { slugEvent, zoneId } = useParams()
  const history = useHistory()
  const [ready, setReady] = useState(false)
  const [modalShow, setModalShow] = useState(false)
  const [modalTitle, setModalTitle] = useState('')
  const [currentZone, setCurrentZone] = useState({})
  const [title, setTitle] = useState('Detalle del evento')
  const [loadMap, setLoadMap] = useState(false)

  const { rows, isProcessing, error } = useGet({
    url: '/event/search/by/slug/' + slugEvent
  })

  // Carga de datos base del evento
  useEffect(() => {
    if (!isProcessing) {
      if (!rows || rows.length === 0) {
        history.push(appUrl({ url: '/' }))
      } else {
        setTitle(rows.name_event)
        setReady(true)

        // Si viene con zona en la URL, abrir directamente el modal
        if (zoneId && rows.event_zone) {
          const zone = rows.event_zone.find(
            zone => parseInt(zone.id_event_zone) === parseInt(zoneId)
          )

          if (zone) {
            setCurrentZone(zone)
            setModalTitle('Comprar entradas: ' + zone.name_event_zone)
            setModalShow(true)
          }
        }
      }
    }
  }, [rows, error, isProcessing, history, zoneId])

  const modalHide = () => {
    setModalShow(false)
  }

  // Carga dinámica de jQuery y mapster
  useEffect(() => {
    const loadScript = (src, callback) => {
      const script = document.createElement('script')
      script.src = src
      script.onload = callback
      document.body.appendChild(script)
    }

    loadScript(
      'https://miraticket.store/app/jquery.js',
      () => {
        loadScript(
          'https://miraticket.store/app/jquery.imagemapster.min.js',
          () => {
            setLoadMap(true)
          }
        )
      }
    )
  }, [])

  // Configurar mapa de zonas
  useEffect(() => {
    if (!isProcessing && loadMap && rows && rows.event_zone) {
      if (
        typeof window.jQuery !== 'undefined' &&
        typeof window.jQuery.fn.mapster === 'function'
      ) {
        let htmlMap = ''
        rows.event_zone.forEach(zone => {
          const isSoldOut = parseInt(zone.sold_out) === 1
          if (!isSoldOut && zone.coordinates) {
            htmlMap += `<area shape="rect" coords="${zone.coordinates}" alt="${zone.name_event_zone}" href="#" data-name="${zone.id_event_zone}" />`
          }
        })

        setTimeout(() => {
          const mapElement = document.getElementById('map-mapping')
          if (!mapElement) return

          mapElement.innerHTML = htmlMap

          window.jQuery('#concert-image').mapster({
            fillColor: 'A9A9A9',
            fillOpacity: 0.4,
            stroke: true,
            strokeColor: 'A9A9A9',
            strokeOpacity: 1,
            strokeWidth: 2,
            mapKey: 'data-name',
            showToolTip: true,
            toolTipClose: ['area-mouseout'],
            onClick: function (id_event_zone) {
              const zone = rows.event_zone.find(
                zone =>
                  parseInt(zone.id_event_zone) ===
                  parseInt(id_event_zone.key)
              )
              if (!zone) return true

              setCurrentZone(zone)
              setModalTitle('Comprar entradas: ' + zone.name_event_zone)
              setModalShow(true)
              return true
            }
          })
        }, 1000)
      }
    }
  }, [loadMap, isProcessing, rows])

  if (!ready) {
    return <LoadingIcon />
  }

  return <Layout title={title}>
    <EventPage rows={rows} setCurrentZone={setCurrentZone} setModalTitle={setModalTitle} setModalShow={setModalShow} currentZone={currentZone} modalShow={modalShow} modalTitle={modalTitle} />
    <Modal
      show={modalShow}
      onHide={modalHide}
      backdrop="static"
      size="lg"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title as="div">{modalTitle}</Modal.Title>
      </Modal.Header>

      {/* Fondo gris suave para separar del modal blanco */}
      <Modal.Body className="bg-light">
        {/* Contenedor general del contenido */}
        <div className="ticket-modal-wrapper">
          {/* Resumen superior de la zona */}
          <div className="card border-0 shadow-sm mb-4">
            <div className="card-body d-flex flex-wrap justify-content-between align-items-center gap-2">
              <div>
                <div className="small text-uppercase text-muted mb-1">
                  Zona seleccionada
                </div>
                <div className="d-flex flex-wrap align-items-baseline gap-2">
                  <h5 className="mb-0">
                    <span
                      style={{
                        borderLeft: `4px solid ${currentZone.color_event_zone || '#000'}`,
                        paddingLeft: '0.5rem'
                      }}
                    >
                      {currentZone.name_event_zone}
                    </span>
                  </h5>
                  <span className="badge bg-secondary">
                    {currentZone.name_type_event_zone}
                  </span>
                  {parseInt(currentZone.id_type_event_zone) === 3 && (
                    <small className="text-muted">
                      · {currentZone.qty_event_zone} personas por box
                    </small>
                  )}
                </div>
              </div>

              <div className="text-end">
                <div className="small text-muted mb-1">Precio por compra</div>
                <div className="fs-5 fw-bold text-primary">
                  {currentZone.name_money} {currentZone.price_event_zone}
                </div>
              </div>
            </div>
          </div>

          {/* Dos columnas principales */}
          <div className="row g-4">
            {/* <div className="col-12">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-body">
                  {parseInt(currentZone.qty_event_zone) > 1 && (
                    <p className="text-muted small mb-3">
                      Las entradas para el evento <strong>{currentZone.name_event}</strong>{' '}
                      se venden en paquetes para un mínimo de{' '}
                      <strong>{currentZone.qty_event_zone}</strong> personas.
                      Al seleccionar una entrada, ya se incluye este mínimo de personas
                      y el costo correspondiente.
                    </p>
                  )}

                  {currentZone.image_event_zone && (
                    <>
                      <div className="mb-2">
                        <TransformWrapper>
                          <TransformComponent>
                            <img
                              src={apiResource({
                                url: currentZone.image_event_zone
                              })}
                              alt={`Mapa de la zona ${currentZone.name_event_zone}`}
                              className="img-fluid rounded"
                            />
                          </TransformComponent>
                        </TransformWrapper>
                      </div>
                      <small className="text-muted">
                        Acerca la imagen para ver mejor la distribución de la zona.
                      </small>
                    </>
                  )}

                  {!currentZone.image_event_zone && (
                    <p className="text-muted small mb-0">
                      No hay mapa asociado a esta zona, pero puedes continuar con tu
                      reserva sin problemas.
                    </p>
                  )}
                </div>
              </div>
            </div> */}

            {currentZone.image_event_zone && (
              <div className="col-12">
                <div className="mb-2 d-flex justify-content-center">
                  <TransformWrapper>
                    <TransformComponent>
                      <img
                        src={apiResource({
                          url: currentZone.image_event_zone
                        })}
                        alt={`Mapa de la zona ${currentZone.name_event_zone}`}
                        className="img-fluid rounded"
                      />
                    </TransformComponent>
                  </TransformWrapper>
                </div>
                <small className="text-muted d-flex justify-content-center">
                  Acerca la imagen para ver mejor la distribución de la zona.
                </small>
              </div>
            )}

            {/* Columna derecha: bloque de reserva */}
            <div className="col-12">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-body d-flex flex-column">
                  <div className="mb-3">
                    <h5 className="mb-1">Completar reserva</h5>
                    <small className="text-muted">
                      Indica la cantidad de entradas y completa los datos solicitados.
                      Podrás revisar el detalle antes de finalizar tu compra.
                    </small>
                  </div>

                  {/* Aquí montamos el formulario según el tipo de zona */}
                  <div className="flex-grow-1 d-flex flex-column">
                    {parseInt(currentZone.id_type_event_zone) === 1 ? (
                      <ZoneGeneralForm idEventZone={currentZone.id_event_zone} />
                    ) : (
                      <ZoneBoxForm idEventZone={currentZone.id_event_zone} />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  </Layout>
}
